import React, { Fragment, useEffect, useState } from 'react'
import { array, bool, func, object, string } from 'prop-types'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import RadioGroup from '@taglivros/oef_componentes/build/components/radioGroup'
import RadioButton from '@taglivros/oef_componentes/build/components/radioButton'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import { formatCEP } from '../../../utils/formatter/formatter'
import { DESCRICAO_MODAL_ESCOLHER_ENDERECO, ID_CADASTRO_NOVO_ENDERECO, TITULO_MODAL_ESCOLHER_ENDERECO } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { MODALIDADE_CURADORIA } from '../../../constants'

const WrapperModal = styled.div`
  width: 100%;

  p {
    margin: 0;
  }

  #outros-enderecos {
    flex-wrap: wrap;

    & > div {
      align-items: flex-start;
      margin-bottom: 10px;
      width: 100%;

      @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
        width: calc((100%/2) - 10px);
      }
    }
  }

  .conteudo__modal__endereco {
    margin: 0 auto;
    max-width: 375px;
    text-align: center;

    p {
      ${StyleGuide.tipografia.textoPequeno}
      margin: 5px 0 40px;
    }
  }

  .botao__modal__endereco {
    margin-top: 40px;
    text-align: center;

    & > button:last-of-type {
      @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
        margin-left: 10px;
      }
    }
  }

  .radioLabel {
    margin-bottom: 20px;

    > div {
      border-color: ${( { tema } ) => tema} !important;
      &::after {
        background: ${( { tema } ) => tema} !important;
      }
    }
  }

  .wrapper__radio__button {
    cursor: pointer;

    .endereco__vigente {
      ${StyleGuide.tipografia.textoDefault};
      ${StyleGuide.boldFonte};
      color: ${( { tema } ) => tema};
      margin: 0;
      margin-bottom: 5px;
    }
  }
`

const ModalEscolherEndereco = ( { closeModal, enderecoSelecionado, enderecoVigente, enderecos, setEnderecoSelecionado, setIdEnderecoSelecionado, showModal, tema } ) => {
  const [ listagemEndereco, setListagemEndereco ] = useState( [] )
  const [ selecaoIdEnderecoModal, setSelecaoIdEnderecoModal ] = useState()

  useEffect( () => {
    if ( enderecos.length ) {
      let novosEnderecos = []
      if ( !isEmptyObject( enderecoSelecionado ) && enderecoSelecionado.id !== ID_CADASTRO_NOVO_ENDERECO ) {
        novosEnderecos = enderecos
          .filter( endereco => enderecoSelecionado === enderecoVigente && ( endereco.vigencia.pendente || !endereco.vigencia.modalidades.length ) )
      }

      const divisaoEnderecos = ( novosEnderecos.length > 1 ? novosEnderecos : enderecos ).slice( 0, 2 )
      setListagemEndereco( divisaoEnderecos )
      setSelecaoIdEnderecoModal( divisaoEnderecos[ 0 ].id )
    }
  }, [ enderecoSelecionado, enderecos ] )

  return (
    <Modal
      altura="auto"
      largura="560px"
      onShowModal={ closeModal }
      show={ showModal }
    >
      <WrapperModal
        tema={ tema }
      >
        { listagemEndereco.length ?
          <Fragment>
            <div className="conteudo__modal__endereco">
              <h3>{ TITULO_MODAL_ESCOLHER_ENDERECO }</h3>

              <p>{ DESCRICAO_MODAL_ESCOLHER_ENDERECO }</p>
            </div>

            <RadioGroup
              defaultOption={ selecaoIdEnderecoModal }
              group="outros-enderecos"
              itemsDirection="row"
              itemsPadding="0"
              listDirection={ `${StyleGuide.isMobile() ? 'column' : 'row'}` }
              onChange={ codigo => {
                const enderecoSelecionadoId = Number( codigo.optionChecked )
                setSelecaoIdEnderecoModal( enderecoSelecionadoId )
              } }
            >
              { listagemEndereco.map( endereco => (
                <RadioButton
                  group="outros-enderecos"
                  id={ endereco.id }
                  key={ endereco.id }
                  value={ endereco.id }
                >
                  <div className="wrapper__radio__button">
                    {endereco.id === enderecoVigente.id && <p className="endereco__vigente">Endereço vigente</p>}

                    <p>{ `${endereco.rua}${endereco.complemento ? ` - ${endereco.complemento}` : ''}` }</p>

                    <p>{ `Bairro ${endereco.bairro}` }</p>

                    <p>{ `CEP ${formatCEP( endereco.cep )}` }</p>

                    <p>{ `${endereco.cidade} - ${endereco.uf}` }</p>
                  </div>
                </RadioButton>
              ) ) }
            </RadioGroup>

            <div className="botao__modal__endereco">
              <Button
                fullWidth={ StyleGuide.isMobile() }
                invertido
                onClick={ closeModal }
                tema={ tema === MODALIDADE_CURADORIA.cor ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
              >
                Fechar
              </Button>

              <Button
                fullWidth={ StyleGuide.isMobile() }
                hasSpaceBottom={ !StyleGuide.isMobile() }
                onClick={ () => {
                  const enderecoSelecionadoPorId = listagemEndereco.find( endereco => endereco.id === selecaoIdEnderecoModal )
                  setEnderecoSelecionado( enderecoSelecionadoPorId )
                  setIdEnderecoSelecionado( selecaoIdEnderecoModal )
                  closeModal()
                } }
                tema={ tema === MODALIDADE_CURADORIA.cor ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
              >
                Continuar
              </Button>
            </div>
          </Fragment> : null}
      </WrapperModal>
    </Modal>
  )
}

ModalEscolherEndereco.defaultProps = {
  'tema': StyleGuide.cores.azul
}

ModalEscolherEndereco.propTypes = {
  'closeModal': func.isRequired,
  'enderecoSelecionado': object.isRequired,
  'enderecoVigente': object.isRequired,
  'enderecos': array.isRequired,
  'setEnderecoSelecionado': func.isRequired,
  'setIdEnderecoSelecionado': func.isRequired,
  'showModal': bool.isRequired,
  'tema': string
}

export default ModalEscolherEndereco
